<template>
  <div>
  <div v-if="!isResouceExist" class="outdata">
    该页面已停止访问
  </div>
  <div v-if="isResouceExist">
    <div class="top-box" ref="top-box">
      <headerImg
        :fixed="fixedStatus"
        :flag1="tmpHeaderTextFl*1"
        :baseInfo="baseInfo"
        :color="color"
        :tmpRegisterFl="tmpRegisterFl"
        @login="login"
        @loaded="imgload=true"
        :navs2="navs2"
        :isregister='isregister'
        v-if="navs2"
        :url="bannerImg"
        :slides="slides"></headerImg>
      <div style="height:50px;margin-top: -25px;">
        <i-nav
          v-if="navs2"
          @closeSearch="search=0"
          @fixemit="fixemit"
          :color="color"
          :navs="navs"></i-nav>
      </div>
      <div v-show="!search">
        <div :id="`id_${item.navId}`" style="width: 1000px;margin: 0 auto;" v-for="(item,i) in componentsList" :key="i">
          <top-bar :color="color" v-if="!item.navUrl && item.navType != 6" :data="item" :text="item.navName"></top-bar>
          <div v-if="item.navType != 6" v-for="(c,j) in item.comps" :key="j">
            <secondTitle
              v-if="item.comps.length>1&&c.cpnCode!='cal'&&c.cpnCode!='live'"
              style="margin-top: 5px;"
              :color="color"
              :name="c.cpnTitle">
            </secondTitle>
            <div
              style="margin-top: 10px;margin-left: 20px;"
              v-if="c.cpnCode==='def'"
              class="v-html"
              v-html="c.cpnContent"></div>
            <i-teacher
              :info="c"
              v-if="c.cpnCode === 'vip'"
              :dataInfo="c.cpnData">
            </i-teacher>
            <daily
              v-if="c.cpnCode === 'cal'"
              @search="searchFun"
              :color="color"
              :dataInfo="c.cpnData"
              :width="989"></daily>
            <consultation
              :color="color"
              v-if="c.cpnCode === 'info'"
              :data="c.cpnData"></consultation>
            <livecom :padding="false" v-if="c.cpnCode == 'live'" :showTop="false" :width="188" :showNum="5"
                     :data="c"></livecom>
            <!--<base-info v-if="c.cpnCode === 'base'" :baseInfos="c.cpnData"></base-info>-->
          </div>
        </div>
      </div>
      <div v-if="search && searchData">
        <dailySearch :color="color" :propData="searchData"></dailySearch>
      </div>
    </div>
    <div ref="bannerImg" v-if="bannerImg" style="text-align: center;margin-top: 70px;font-size: 0;">
      <img :src="tmpBottomImg" alt="">
    </div>
    <login
      @close='login2'
      :color="color"
      :showBox="showBox"></login>
  </div>
  </div>
</template>
<script>
  import topBar from './topBar'
  import iNav from './iNav'
  import iTeacher from './iTeacher'
  import daily from '../tpl2/daily'
  import baseInfo from '../tpl1/baseInfo'
  import secondTitle from '../tpl1/secondTitle'
  import headerImg from '../tpl1/headerImg'
  import login from '../login/login'
  import dailySearch from '../tpl2/dailySearch'
  import consultation from 'base/consultation'
  import livecom from '@/components/livecom/livecom'
  export default {
    data () {
      return {
        isResouceExist: true,
        showBox: false,
        bannerImg: '',
        navs2: "",
        navs: [],
        componentsList: [],
        color: '#f39800',
        baseInfo: {},
        tmpBottomImg: '',
        tmpHeaderTextFl: 0,
        tmpRegisterFl: 1,
        search: 0,
        fixedStatus: false,  //导航当前状态
        searchData: '', //搜索日程数据
        imgload: false,
        isregister:'',

        //轮播图
        slides:[]
      }
    },
    components: {
      consultation, iNav, topBar, iTeacher, daily, baseInfo, secondTitle, headerImg, login, dailySearch, livecom
    },
    mounted(){
      // 根据语言  获取data  语言在 router beforeeach 中已经设置
      let lang = localStorage.getItem('locale')
      if (lang === 'ch') lang = 'cn'
      this.initData(lang);

    },
    methods: {
      searchFun(data){
        console.log(data);
        this.searchData = data;
        this.search = 1;
      },
      login2(){
        this.showBox = false;
      },
      login(){
        this.showBox = true;
      },
      fixemit(status){
//          当前的状态
        this.fixedStatus = status;
      },
      /**@augments 处理获得模板之后的 逻辑 */
      dataFn(response){

        let data = response.data;
        this.isregister = data.isregister;
        console.log('=============')
        console.log(data)
        if (data.code == '0') {
          let {englishpc} = data
          if (englishpc == 0) {
            // 不支持英文
            localStorage.setItem('englishpc', 0)
            localStorage.setItem('locale', 'ch')
            this.$root._i18n.locale = 'ch'
          } else {
            localStorage.setItem('englishpc', 1)
          }
          document.title = data.data.base_info.cTitle;
          this.color = data.template.tmpColor == null ? '#f39800' : data.template.tmpColor;
          localStorage.setItem('color', this.color);
          this.tmpBottomImg = data.template.tmpBottomImg;
          this.tmpHeaderTextFl = data.template.tmpHeaderTextFl;
          this.tmpRegisterFl = data.template.tmpRegisterFl * 1;
          this.bannerImg = data.template.tmpImg;

          this.slides=data.slides;

          // 如果有直播模块，加到模板最后
          let liveInfo = data.navs.filter((nav) => nav.navType * 1 === 5)
          if (liveInfo.length !== 0) {
            // liveInfo[0].comps.push({cpnData: [],cpnCode: 'live'})
            // liveInfo[0].comps[0].cpnData.push({icons: data.data.icons,lives: data.data.lives,cpnCode: 'live'})
            // data.template.navs.push(liveInfo[0])
            liveInfo[0].comps[0] = {cpnData: {icons: data.data.icons, lives: data.data.lives}, cpnCode: 'live'}
            data.template.navs.push(liveInfo[0])
          }

          this.navs = data.template.navs;
          this.navs2 = data.navs; //额外的功能配置
          this.baseInfo = data.data.base_info;
          this.navs.map((item, i) => {
            if (i === 0) {
              item.active = true;
            } else {
              item.active = false;
            }
          });
          this.componentsList = data.template.navs;
          setTimeout(() => {
            let winHeight = window.document.body.offsetHeight
            let footerHeight = this.$refs['bannerImg'].offsetHeight
            let topBox = this.$refs['top-box']
            topBox.style['min-height'] = winHeight - footerHeight + 'px'
          }, 20);
        } else if (data.code == '1365') {
          this.isResouceExist = false;
        }
      },
      initData(lang){
        let cid = this.$route.params.cid;
        localStorage.setItem('cid', cid);
        let uid = localStorage.getItem('uid');
        //      检测语言
        axios.request({
          url: '/medapp/api/template/con/homepage',
          method: 'post', // default
          data: {
            cid: cid,
            template_type: 1,   // pc 端返回数据
            all_fl: 1,
            uid:uid
          },
          headers: {'language': lang}
        }).then((response) => {
          this.dataFn(response)
        }).catch((error) => {
          axios.request({
            url: '/medapp/api/template/con/homepage',
            method: 'post', // default
            data: {
              cid: cid,
              template_type: 1,   // pc 端返回数据
              all_fl: 1
            },
            headers: {'language': 'cn'}
          }).then((response) => {
            this.dataFn(response)
          })
        })
      }
    }
  }
</script>

<style scoped>
  .banner {
    width: 100%;
    height: 300px;
  }
  .outdata{
    font-size: 40px;color:#333;width:360px;margin:100px auto;
  }
</style>



// WEBPACK FOOTER //
// index.vue?87643946